import BaseClass from "../BaseClass.js";
import {createPicker} from 'picmo';
import {globalConfig} from 'picmo';
import {createPopup} from "@picmo/popup-picker";
import emojiDataDE from 'emojibase-data/de/data.json';
import messagesDE from 'emojibase-data/de/messages.json';
import emojiDataEN from 'emojibase-data/en/data.json';
import messagesEN from 'emojibase-data/en/messages.json';


/**
 * Docs zu EmojiButton: https://picmojs.com/
 */
export default class EmojiPicker extends BaseClass {

    constructor(element) {
        super(element);

        globalConfig.injectStyles = false;

        this.picker = null;
        this.languageStrings = null; // https://picmojs.com/docs/api/picmo/types/dictionary
        this.targetElementId = null;
        this.$target = null; // Input oder Textarea, welches/r befüllt werden soll
        this.pickListener = null;
        this.customLoad = false;
        this.customLoadListener = null;
        this.closeListener = null;
        this.popupMode = false;
        this.hideOnEmojiSelect = false;
        this.eventOnAction = null;
        this.contentId = null;
        this.convId = null;

        this.init();
    }

    init() {
        let mySelf = this;

        this.setLanguageStrings();
        this.targetElementId = this.$element.attr('data-target-id');
        this.$target = $('#' + this.targetElementId);

        this.closeListener = function () {
            mySelf.$target.focus();
        };


        const popupMode = this.$element.attr("data-popup-mode");
        if (popupMode != undefined && popupMode == 1) {
            this.popupMode = true;
        }

        const hideOnSelect = this.$element.attr("data-hide-on-select");
        if (hideOnSelect != undefined && hideOnSelect == 1) {
            this.hideOnEmojiSelect = true;
        }

        const eventOnAction = this.$element.attr("data-event-on-action");
        if (eventOnAction != undefined) {
            this.eventOnAction = eventOnAction;
        }

        const contentId = this.$element.attr("data-content-id");
        if (contentId != undefined) {
            this.contentId = contentId;
        }

        const convId = this.$element.attr("data-conv-id");
        if (convId != undefined) {
            this.convId = convId;
        }

        if (this.popupMode) {
            this.customLoadListener = function (event) {
                if (mySelf.picker == null) {
                    mySelf.loadPopUpPicker();
                }
                if (mySelf.element == event.target) {
                    mySelf.picker.toggle();
                }
            }
            this.$element.on('click', this.customLoadListener);

        } else {
            const customLoad = this.$element.data("custom-load");
            if (customLoad) {
                this.customLoad = true;
            }

            this.customLoadListener = function () {
                mySelf.loadPicker();
                mySelf.$element.off('custom:load', mySelf.customLoadListener);
            }

            if (this.customLoad) {
                this.$element.on('custom:load', this.customLoadListener);
            }

            if (!this.customLoad) {
                this.loadPicker();
            }
        }
    }

    loadPopUpPicker() {
        let mySelf = this;

        const lang = this.$element.data('lang');
        const langConf = this.languageStrings[lang];

        let emojiData = emojiDataEN;
        let messages = messagesEN;

        if (lang == "de") {
            emojiData = emojiDataDE;
            messages = messagesDE;
        }

        this.picker = createPopup({
            emojiData: emojiData,
            messages: messages,
            rootElement: mySelf.element,
            triggerElement: mySelf.element,
            showPreview: false,
            showRecents: true,
            showSearch: true,
            initialCategory: 'recents',
            visibleRows: 5,
            locale: lang,
            i18n: langConf,
            maxRecents: 16,
            hideOnEmojiSelect: mySelf.hideOnEmojiSelect,
            hideOnClickOutside: true,
            onPositionLost: 'destroy',
            position: 'bottom-end',
            autoFocus: false
        }, {
            referenceElement: this.element,
            triggerElement: this.element
        });

        this.pickListener = function (event) {
            if (mySelf.eventOnAction != null) {
                const enhancedEvent = {
                    originalEvent: event,
                    contentId: mySelf.contentId,
                    convId: mySelf.convId
                };

                $(document).trigger(mySelf.eventOnAction, enhancedEvent);
            } else {
                mySelf.pickAction(event);
            }
        }
        this.picker.addEventListener('emoji:select', this.pickListener);
        this.picker.addEventListener('picker:close', this.closeListener);

    }

    loadPicker() {
        let mySelf = this;

        const lang = this.$element.data('lang');
        const langConf = this.languageStrings[lang];

        let emojiData = emojiDataEN;
        let messages = messagesEN;

        if (lang == "de") {
            emojiData = emojiDataDE;
            messages = messagesDE;
        }

        this.picker = createPicker({
            emojiData: emojiData,
            messages: messages,
            rootElement: this.element,
            showPreview: false,
            showRecents: true,
            showSearch: true,
            initialCategory: 'recents',
            visibleRows: 5,
            locale: lang,
            i18n: langConf,
            maxRecents: 16
        });

        // pick
        this.pickListener = function (event) {
            mySelf.pickAction(event);
        }
        this.picker.addEventListener('emoji:select', this.pickListener);
    }

    pickAction(event) {
        if (this.$target != null && this.$target.length > 0) {
            let text = this.$target.val();
            text += event.emoji;
            this.$target.val(text);

            var element = this.$target[0];
            element.addEventListener('focus', function () {
                element.setSelectionRange(9999, 9999);
            });
            element.focus();
            this.$target.trigger('change');
        }
    }

    setLanguageStrings() {
        this.languageStrings = {
            de: {
                'categories.activities': 'Aktivitäten',
                'categories.animals-nature': 'Tiere & Natur',
                'categories.custom': 'Custom',
                'categories.flags': 'Flaggen',
                'categories.food-drink': 'Speisen & Getränke',
                'categories.objects': 'Objekte',
                'categories.people-body': 'Menschen & Körper',
                'categories.recents': 'Zuletzt verwendet',
                'categories.smileys-emotion': 'Smileys & Emotionen',
                'categories.symbols': 'Symbole',
                'categories.travel-places': 'Reisen & Orte',
                'error.load': 'Emojis konnten nicht geladen werden',
                'recents.clear': 'Clear recent emojis',
                'recents.none': 'Du hast noch keinen Emoji ausgewählt.',
                'retry': 'Versuche es nochmal',
                'search.clear': 'Suche zurücksetzen',
                'search.error': 'Suche nach Emojis fehlgeschlagen',
                'search.notFound': 'Keine Einträge gefunden',
                'search': 'Suchen...'
            },
            en: {
                'categories.activities': 'Activities',
                'categories.animals-nature': 'Animals & Nature',
                'categories.custom': 'Custom',
                'categories.flags': 'Flags',
                'categories.food-drink': 'Food & Drink',
                'categories.objects': 'Objects',
                'categories.people-body': 'People & Body',
                'categories.recents': 'Recently Used',
                'categories.smileys-emotion': 'Smileys & Emotion',
                'categories.symbols': 'Symbols',
                'categories.travel-places': 'Travel & Places',
                'error.load': 'Failed to load emojis',
                'recents.clear': 'Clear recent emojis',
                'recents.none': 'You haven\'t selected any emojis yet.',
                'retry': 'Try again',
                'search.clear': 'Clear search',
                'search.error': 'Failed to search emojis',
                'search.notFound': 'No matches',
                'search': 'Search emojis...'
            },
        };
    }

    destroyListener() {
        this.$element.off('custom:load', this.customLoadListener);
        if (this.picker != null) {
            this.picker.removeEventListener('emoji:select', this.pickListener);
        }
    }
}